/**
 * CBE Birr Plus Mini App WebView bridge.
 * window.myJsChannel is injected only when CBE Birr Plus opens this site.
 * Distinct from CBE SuperApp (window.cbesuperapp).
 */

export interface CbeBirrPlusJsChannel {
  postMessage: (data: string) => void
}

export interface CbeBirrPlusCreatePaymentRequest {
  transaction_id: string
  title: string
  amount: number | string
  /** CBE Birr Plus session token from the WebView Authorization header / URL */
  access_token?: string
  paymentMethod?: string
}

export interface CbeBirrPlusCreatePaymentResult {
  token: string
  phone?: string
  [key: string]: unknown
}

export interface CbeBirrPlusPaymentResult {
  token?: string
  paidAmount?: string | number
  paidByNumber?: string
  txnRef?: string
  transactionId?: string
  [key: string]: unknown
}

export type CbeBirrPlusWindow = Window & {
  myJsChannel?: CbeBirrPlusJsChannel
}

declare global {
  interface Window {
    myJsChannel?: CbeBirrPlusJsChannel
  }
}

export function getCbeBirrPlusWindow(): CbeBirrPlusWindow {
  return window as CbeBirrPlusWindow
}
